import axiosInstance from "../axiosClient";
import { addService, EditServiceDetails, servicesList } from "../config";

export const getServices = async (name, limit, start_key) => {
  let queryParams = [];
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
  return await axiosInstance.get(`${servicesList}${queryString}`);
};

export const createService = async (data) => {
  return await axiosInstance.post(addService, data);
};

export const updateServiceDetails = async (data) => {
  return await axiosInstance.put(EditServiceDetails, data);
};
